import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

/**
 * useFounders — singleton hook that fetches the Set of usernames
 * holding a Founders Pass once per session, then returns:
 *   isFounder(username: string) => boolean
 * Used inline by FounderBadge wherever we render @usernames we don't
 * already have a full user object for.
 */
let _cache = null;
let _loading = null;

const fetchOnce = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_loading) return _loading;
  _loading = api.get('/users/founders')
    .then(({ data }) => { _cache = new Set(data.usernames || []); return _cache; })
    .catch(() => { _cache = new Set(); return _cache; });
  return _loading;
};

export const useFounders = () => {
  const [ready, setReady] = useState(!!_cache);
  useEffect(() => {
    if (_cache) return;
    fetchOnce().then(() => setReady(true));
  }, []);
  return {
    ready,
    isFounder: (uname) => _cache ? _cache.has((uname || '').replace(/^@/, '')) : false,
  };
};
